import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app.jsx';
import { ErrorBoundary } from './error-boundary.jsx';
import { FournisseurLangue } from './i18n.jsx';
import './styles.css';

const container = document.getElementById('root');
if (container === null) throw new Error('Élément racine introuvable.');

createRoot(container).render(
  <StrictMode>
    <FournisseurLangue>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </FournisseurLangue>
  </StrictMode>,
);
